import {  Popover } from 'element-ui';

export default {
    name: 'ClubBronze',
    props: {
        type: [String, Number],
        size: { type: String, default: 'medium' },
        hintCustom: { type: String, default: null }
    },
    components: {
        [Popover.name]: Popover,
    },
    watch: {
        type: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal == 1) {
                    this.path = this.pathGold;
                    this.hint = this.currentHint ? this.currentHint : this.hintGold;
                } else if (newVal == 2) {
                    this.path = this.pathSilver;
                    this.hint = this.currentHint ? this.currentHint : this.hintSilver;
                }
                else if (newVal == 3) {
                    this.path = this.pathBronze;
                    this.hint = this.currentHint ? this.currentHint : this.hintBronze;
                } else {
                    this.path = '';
                }
            }
        },
    },
    data() {
        return {
            path: '',
            hint: '',


            pathBronze: '/static/images/club-standards/medal-third-place.png',
            pathSilver: '/static/images/club-standards/medal-second-place.png',
            pathGold: '/static/images/club-standards/medal-first-place.png',

            imageBronze: require('@/../static/images/club-standards/medal-third-place.png'),
            imageSilver: require('@/../static/images/club-standards/medal-second-place.png'),
            imageGold: require('@/../static/images/club-standards/medal-first-place.png'),

            hintBronze: 'Congratulations, your club has now achieved the Bronze Standard Level for Triathlon Ireland.',
            hintSilver: 'Congratulations, your club has now achieved the Silver Standard Level for Triathlon Ireland.',
            hintGold: 'Congratulations, your club has now achieved the Gold Standard Level for Triathlon Ireland.',
            
        }
    },
    computed: {
        currentHint() {
            if (this.hintCustom) {
                return this.hintCustom;
            }
            return null;
        }
    },
    methods: {
        getStyle() {
            switch (this.size) {
                case 'medium': return { "width": "30px" };
                case 'small': return { "width": "15px" };
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/medals/club/decider/decider.js